module.exports = __webpack_public_path__ + "img/liza-vincent.228d706d.jpeg";